import { fetchUtils, Options } from 'react-admin';
import { config } from './config';
import { sessionStorageTokenKey } from './constants';

export const httpClient = (route: string, options: Options & { token?: string } = {}) => {
  if (!options.headers) {
    options.headers = new Headers({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    });
  }
  const token = sessionStorage.getItem(sessionStorageTokenKey) || options.token;
  if (token) {
    (options.headers as Headers).set('Authorization', `Bearer ${token}`);
  }

  return fetchUtils.fetchJson(`${config.API}${route}`, options);
};
